import { users as typesUsers } from '../index';

export const provinceFull: Record<string, string> = {
    1: 'JAWA BARAT',
    2: 'BANTEN',
    3: 'DKI JAKARTA',
    4: 'DI YOGYAKARTA',
    5: 'JAWA TENGAH',
    6: 'JAWA TIMUR',
    7: 'BENGKULU',
    8: 'JAMBI',
    9: 'NANGGROE ACEH DARUSSALAM',
    10: 'SUMATERA UTARA',
    11: 'SUMATERA BARAT',
    12: 'RIAU',
    13: 'SUMATERA SELATAN',
    14: 'KEPULAUAN BANGKA BELITUNG',
    15: 'LAMPUNG',
    16: 'KALIMANTAN SELATAN',
    17: 'KALIMANTAN BARAT',
    18: 'KALIMANTAN TIMUR',
    19: 'KALIMANTAN TENGAH',
    20: 'SULAWESI TENGAH',
    21: 'SULAWESI SELATAN',
    22: 'SULAWESI UTARA',
    23: 'GORONTALO',
    24: 'SULAWESI TENGGARA',
    25: 'NUSA TENGGARA BARAT',
    26: 'BALI',
    27: 'NUSA TENGGARA TIMUR',
    28: 'MALUKU',
    29: 'PAPUA TENGAH',
    30: 'MALUKU UTARA',
    31: 'KEPULAUAN RIAU',
    32: 'SULAWESI BARAT',
    33: 'PAPUA BARAT',
    34: 'PAPUA TIMUR',
    35: 'KALIMANTAN UTARA',
};

export const employmentTypeFull: Record<string, string> = {
    occupation_1: 'Legislative and Government Official',
    occupation_2: 'Government Employee (including pensioner)',
    occupation_3: 'BI/BUMN/BUMD Employee (including pensioner)',
    occupation_4: 'Political Party Administrator',
    occupation_5: 'Private Employee',
    occupation_6: 'Professional and Consultant',
    occupation_7: 'Foundation/other legal entity administrator and employee',
    occupation_8: 'NGO/other non-legal entity administrator and employee',
    occupation_9: 'Bank Employee',
    occupation_10: 'Money Changer Employee',
    occupation_30: 'Teacher and Lecturer',
    occupation_33: 'TNI/POLRI (including pensioner)',
    occupation_38: 'Entrepreneur',
    occupation_40: 'Farmer and Fisherman',
    occupation_55: 'Laborer/Household Assistant and Security Personnel',
    occupation_58: 'Trader',
    occupation_68: 'Craftsman',
    occupation_74: 'Ulama/Priest/Leader of religious organizations and groups',
    occupation_76: 'Foundation/other legal entity administrator and employee',
    occupation_80: 'Other',
};

export const baasEmploymentTypeFull: Record<string, string> = {
    "1": "Pejabat Lembaga Legislatif dan Pemerintah",
    "2": "PNS (termasuk pensiunan)",
    "3": "Pegawai BI/BUMN/BUMD (termasuk pensiunan)",
    "4": "Pengurus Parpol",
    "5": "Pegawai Swasta",
    "6": "Profesional dan Konsultan",
    "7": "Pengurus dan pegawai Yayasan/Lembaga Berbadan Hukum Lainnya",
    "8": "Pengurus/Pegawai LSM/Organisasi Tidak Berbadan Hukum Lainnya",
    "9": "Pegawai Bank",
    "10": "Pegawai Money Changer",
    "30": "Pengajar dan Dosen",
    "33": "TNI/Polri (termasuk pensiunan)",
    "38": "Pengusaha/Wiraswasta",
    "40": "Petani dan Nelayan",
    "55": "Buruh/Pembantu Rumah Tangga dan Tenaga Keamanan",
    "58": "Pedagang",
    "68": "Pengrajin",
    "74": "Ulama/Pendeta/Pimpinan Organisasi dan Kelompok Keagamaan",
    "76": "Pengurus dan Pegawai Yayasan/Lembaga Berbadan Hukum Lainnya", // duplicate
    "80": "Lain-Lain",
    "81": "Tracking", // Shouldn't be used as it is not in the list
    "82": "Ibu Rumah Tangga",
    "83": "Pelajar",
}

export type TAddress = {
    address: string;
    province: string;
    cityRegency: string;
    postalCode: string;
    district: string;
    country?: string;
};

export interface IEKYCDetails {
    name: string;
    idNumber: string;
    gender: string;
    dateOfBirth: string;
    placeOfBirth: string;
    maritalStatus: string;
    idType: string;
    idAddress: TAddress;
    residentialAddress: TAddress;
    nationality?: string;
    employmentType: string;
    [key: string]: any;
}

export type TUsers = {
    createdAt: string;
    updatedAt: string;
    phoneNumber: string;
    firstName: string;
    id: string;
    nexId: string;
    lastName: string;
    loginBlockedAt?: string;
    ekycStatus: EEkycStatuesesApi;
    nexCashBalance: number;
    ktpNumber: string | null;
    linkedMerchantIds: string[];
    status: EUserStatus;
    rejectionNote: string | null;
    ekycDetails: IEKYCDetails;
    latestRiskProfile: IRiskProfile | null
};

export type TUsersParams = {
    nexId?: string;
    name?: string;
    phoneNumber?: string;
    ekycStatus?: string;
    status?: string;
    page: number;
    limit: number;
};

export type TUsersResponse = {
    users: TUsers[];
    currentPage: number;
    count: number;
    lastPage: number;
};

export type TUsersPaginationDownload = {
    filename: string;
    data: string;
};

export type TUserQueryParamsFromUrl = TUsersParams & {
    page: string;
    limit: string;
};

export interface IRiskDataModel {
    provinceAddress: string | null // unverified user has null
    occupation: string | null // unverified user has null
    initialTopUpAmount: number | null // unverified user has null
    domicile?: string | null // nullable, we might need it in the future, for now can ignore it
}

export interface IRiskProfile {
    id: string
    riskScore: number
    riskData: IRiskDataModel
    note: string | null
    createdAt: string
    updatedAt: string
}

export type TUsersDetail = {
    id: string;
    nexId: string;
    status: EUserStatus;
    firstName: string | null;
    lastName: string | null;
    loginBlockedAt: string | null;
    createdAt: string;
    updatedAt: string;
    phoneNumber: string;
    linkedMerchantIds: string[] | null;
    ekyc: {
        status: number;
        ktpNumber: string | null;
        rejectionNote?: string | null;
    };
    wallet: {
        balance: number;
        accountNo: string | null;
    };
    riskProfile: IRiskProfile | null
};

export type TUserIdParams = {
    id: string;
};

export type TUser_e_kyc_getResp = {
    selfie: string;
    ktp: string;
};

export type TUser_e_kyc_setParams = {
    statusId: EEkycStatuesesApi;
    comment?: string;
    details?: typesUsers.IEKYCDetails;
};

export type TUserEkycSetResponse = {
    statusId: EEkycStatuesesApi;
};

export type TUserSuspendParams = {
    id: string;
    reason: string;
};

export type TUserDelParams = {
    id: string;
    reason: string;
};

export enum EUserStatus {
    ACTIVE = 'ACTIVE',
    SUSPENDED = 'SUSPENDED',
    CLOSED = 'CLOSED',
    DORMANT = 'DORMANT',
}

export enum EEkycStatuesesApi {
    EKYC_STATUS_UNVERIFIED,
    EKYC_STATUS_PROCESSING,
    EKYC_STATUS_VERIFIED,
    EKYC_STATUS_REJECTED,
}

export enum EEkycStatuses {
    UNVERIFIED = 'UNVERIFIED',
    PROCESSING = 'PROCESSING',
    VERIFIED = 'VERIFIED',
    REJECTED = 'REJECTED',
}

export enum EManageAccountAction {
    RESET_PIN = 'Reset PIN',
    LOCK_ACCOUNT = 'Lock account',
    UNLOCK_ACCOUNT = 'Unlock account',
    SUSPEND_ACCOUNT = 'Suspend account',
    ACTIVATE_ACCOUNT = 'Activate account',
    CLOSE_ACCOUNT = 'Close account',
}

export interface IKTPValidation {
    id: string;
    created: string;
    updated: string;
    id_card_number: string;
    name: string;
    birthdate?: string;
    status?: string;
    is_verified?: boolean;
    email?: string;
    phone?: string;
    failure_reason?: string;
}

export type TCFTResult = {
    id: string;
    score: number;
    names: string[];
    nationalities: string[];
    dates_of_birth: string[];
    scopes: string[];
};

export interface IPEPCFTCheck {
    created: string;
    updated: string;
    id: string;
    reference_id: null | any;
    addresses: any[];
    scopes: string[];
    score_threshold: number;
    status: string;
    user_id: string;
    given_names: string;
    gender: null | any;
    surname?: string | null;
    nationality?: string;
    date_of_birth?: string;
    phone_number?: string | null;
    email?: string | null;
    results: TCFTResult[];
}

export interface IEKYCValidations {
    ktpValidation: IKTPValidation;
    pepCftValidation: IPEPCFTCheck;
}

export interface IGetEKYCDetailsResponse {
    id: string;
    ktp: string;
    selfie: string;
    ekycDetails: IEKYCDetails | string;
    rejectionNote: string | null;
    status: EEkycStatuesesApi;
    validations: IEKYCValidations | null;
    submittedAt: string | null;
    submissionUpdatedAt: string | null;
}

export interface IEKYCUserDocument {
    type: string;
    imageData: {
        content: string;
        name: string;
        type: string;
    };
}

export interface IEKYCUserFormat {
    id: string;
    ekycDocuments: IEKYCUserDocument[];
    ekycDetails: IEKYCDetails;
    validations?: IEKYCValidations;
}
